import React from 'react';
import { Link } from 'react-router-dom';
import '../../stylesheets/home/hero.css'; // Mantenemos tus estilos

function Hero() {
  return (
    <section className="hero">
      <div className="hero_content">
        <h1>
          {/* Se eliminó "la" antes de Comunidad */}
          Productividad 360°: fortalece tu perfil, tu emprendimiento, tu proyecto de vida
        </h1>
        <p>
          {/* Texto actualizado según la imagen */}
          Formación, wizards con IA, mentor IA 24/7.
        </p>
        <Link to="/plans/" className="cta-button">
          Conoce nuestros asistentes IA
        </Link>
      </div>
    </section>
  );
}

export default Hero;